import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SearchIcon = React.forwardRef(function SearchIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M23.41 20.59L17.41 14.59C17.13 14.31 16.79 14.14 16.44 14.06C17.42 12.61 18 10.87 18 9C18 4.04 13.96 0 9 0C4.04 0 0 4.04 0 9C0 13.96 4.04 18 9 18C10.87 18 12.61 17.42 14.05 16.44C14.13 16.8 14.3 17.14 14.58 17.41L20.58 23.41C20.98 23.8 21.49 24 22 24C22.51 24 23.02 23.8 23.41 23.41C24.2 22.63 24.2 21.37 23.41 20.59ZM9 16C5.14 16 2 12.86 2 9C2 5.14 5.14 2 9 2C12.86 2 16 5.14 16 9C16 12.86 12.86 16 9 16Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

SearchIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SearchIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SearchIcon
